import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const OrderedList = (props) => (
  <Icon viewBox="0 0 30 30" {...props}>
    <g>
      <path d="M8 21h2l-1 1 1 1H8v1h3v-1l-1-1 1-1v-1H8v1zm0-6h2.1L8 17v1h3v-1H9.1l1.9-2v-1H8v1zm1-3h1V8H8v1h1v3zm4-1h10V9H13v2zm0 6h10v-2H13v2zm0 6h10v-2H13v2z" />
    </g>
  </Icon>
);
/*eslint-enable */

export default OrderedList;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/OrderedList.js